const reduxStoreExternal = {
    sourceData: {},
    nodesSource: {},
    edgesSource: {},
    attributeImage: {},
    updates: {},
    groupsLoaded: {}
};
export default reduxStoreExternal;
